import React from 'react';
import LoadingAnimation from './LoadingAnimation';

export default class FullScreenLoadingAnimation extends React.Component {
  render () {
    return (
      <div className="c-full-screen-loading-animation">
        <LoadingAnimation/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Components/FullScreenLoadingAnimation.js